import { useMediaQuery } from '@mui/material'
import { Typography, Grid } from '@mui/material'

export default function NorthwellHeader (props) {
  const isMobile = useMediaQuery('(max-width:767px)')
  const { formHeader } = props

  return (
    <Grid
      container
      sx={{
        height: isMobile ? '56px' : '72px',
        backgroundColor: '#009adf',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
      }}>
      <Grid
        item
        id='centeredhone'
        sx={{
          maxWidth: '1140px',
          width: '100%',
          marginLeft: { xs: 0, sm: 'auto' },
          marginRight: { xs: 0, sm: 'auto' },
          paddingLeft: '30px',
          paddingRight: '30px',
        }}>
        <Typography
          id='pageTextHeader'
          variant='h1'
          sx={{
            fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
            color: 'white',
            fontWeight: 'normal',
            textAlign: { xs: 'center', sm: 'left' },
          }}>
          {formHeader}
        </Typography>
      </Grid>
    </Grid>
  )
}
